import React, { createContext, useContext, useEffect } from "react";
import domains from "../config/domains"

// 1. Criação do Contexto
const ThemeContext = createContext();

const getThemeConfig = () => {
  const site = process.env.REACT_APP_SITE;

  switch (site) {

    case "auditivo":
      return {
        title: "Aparelhos Auditivos | Bianco Azure",
        context: "aparelhos auditivos",
        bgColor: "bg-[#BB9EFF]/70",
        linkPrefix: "/auditivo",
        textColor: "text-white",
        navTextColor: "text-white/90",
        hoverTextColor: "hover:text-white",
        buttonBg: "bg-black",
        buttonHoverBg: "hover:bg-gray-800",
        backdrop: "backdrop-blur-md rounded-md",
        border: "border-purple-600",
        gradientColor: "#f3f6f8",
        progressBar: "#5810FF",
      };

    case "respiratorio":
      return {
        title: "Equipamentos Respiratórios | Bianco Azure",
        context: "aparelhos respiratórios",
        bgColor: "bg-green-600/70",
        linkPrefix: "/equipamento",
        textColor: "text-white",
        navTextColor: "text-white/90",
        hoverTextColor: "hover:text-white",
        buttonBg: "bg-black",
        buttonHoverBg: "hover:bg-gray-800",
        backdrop: "backdrop-blur-md rounded-md",
        border: "border-green-800",
        gradientColor: "#f3f6f8",
        progressBar: "#10FF6C",
      };

    case "homecare":
      return {
        title: "HomeCare | Bianco Azure",
        context: "homecare",
        bgColor: "bg-[#66B4FF]/70",
        linkPrefix: "/homecare",
        textColor: "text-white",
        navTextColor: "text-white/90",
        hoverTextColor: "hover:text-white",
        buttonBg: "bg-black",
        buttonHoverBg: "hover:bg-gray-800",
        backdrop: "backdrop-blur-md rounded-md",
        border: "border-blue-700",
        gradientColor: "#f3f6f8",
        progressBar: "#108AFF",
      };

    // Padrão: Institucional
    default:
      const standardTheme = {
        title: "Institucional | Bianco Azure",
        main: "text-[#00394F]",
        bg: "bg-[#00394F]",
        hoverBg: "hover:bg-[#002c3d]",
        hoverText: "hover:text-[#00394F]",
      };

      return {
        title: standardTheme.title,
        context: "",
        bgColor: "bg-white/80",
        linkPrefix: "",
        textColor: standardTheme.main,
        navTextColor: "text-gray-600",
        hoverTextColor: standardTheme.hoverText,
        buttonBg: standardTheme.bg,
        buttonHoverBg: standardTheme.hoverBg,
        backdrop: "backdrop-blur-sm rounded-md",
        border: "border-gray-300",
        gradientColor: "#9DCEF9",
        progressBar: "#00394F",
        isStandard: true,
      };
  }
};

// 2. Provider
export const ThemeProvider = ({ children }) => {
  const theme = getThemeConfig();

  // 🎯 Atualiza o <title> automaticamente
  useEffect(() => {
    if (theme.title) {
      document.title = theme.title;
    }
  }, [theme.title]);

  return (
    <ThemeContext.Provider value={{ theme, domains }}>
      {children}
    </ThemeContext.Provider>
  );
};

// 3. Hook customizado
export const useTheme = () => useContext(ThemeContext);